module.exports = __webpack_public_path__ + "img/logo_drawer_2.ce4a136a.png";